import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { Form } from 'antd';
import BtnBlock from './components/BtnBlock';
import NameField from './components/NameField';
import ModalWindows from './components/ModalWindows';
import {
	EditGameDeveloperContext,
	IEditGameDeveloperContext,
} from './editDeveloperModalContext/editDeveloperModalState/editDeveloperModalContext';
import { preventDefaultForEnterKey } from 'utils/helpers';
import classNames from 'classnames';
import style from './EditDeveloperModal.module.scss';

interface IEditDeveloperModal {
	isVisible: boolean;
}

const EditDeveloperModal: React.FC<IEditDeveloperModal> = ({ isVisible }) => {
	const { setDataForSubmit, changeTypeOfModalWindow, changeName, developerID, name } =
		useContext<IEditGameDeveloperContext>(EditGameDeveloperContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ name });
	}, [name]);

	const submit = () => {
		setDataForSubmit({
			id: developerID,
			name,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={containerClasses} data-test="EditDeveloperModal">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.wrapper}>
					<div className={style.content}>
						<Text
							className={style.heading}
							translationNameSpace="form"
							translationKey="editingDeveloperHeading"
							size="xxl"
							weight="bold"
						/>
						<NameField changeName={changeName} />
					</div>
					<BtnBlock />
				</div>
			</Form>
			<ModalWindows />
		</div>
	);
};

export default React.memo(EditDeveloperModal);
